<p-accordion styleClass="accordion-panel" [headerAriaLevel]="4">
    <p-accordionTab [disabled]="disabled" [selected]="selected">
        <ng-template pTemplate="icon"></ng-template>
        <ng-template pTemplate="header">
            <div [ngClass]="{'flex align-items-center':true, 'en': (currentLanguage | async) === 'en'}">
                <span class="vertical-align-middle header" [ngClass]="{'flex align-items-center':true, 'en': (currentLanguage | async) === 'en'}">{{ header }}</span>
                <span *ngIf="count !== null" [ngClass]="{'vertical-align-middle count-items':true, 'en':(currentLanguage|async)==='en'}">{{ count }}</span>
                <i aria-hidden="true" [ngClass]="{'pi pi-chevron-left':true, 'en':(currentLanguage|async)==='en'}"></i>
                <i aria-hidden="true" class="pi pi-chevron-down"></i>
            </div>
        </ng-template>
        <ng-content></ng-content>
    </p-accordionTab>
</p-accordion>